import RestaurantItem from './RestaurantItem';

export default RestaurantItem;
